import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmBarrelMakeForm from '../../../components/forms/FirearmBarrelMakeForm';
import { useCreateFirearmBarrelMake } from '../../../hooks/useFirearmBarrelMakeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmBarrelMakeDTO } from '../../../services/apiClient';

const FirearmBarrelMakeCreate: React.FC = () => {
  const createFirearmBarrelMake = useCreateFirearmBarrelMake();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Barrel Makes', href: '/admin/firearmbarrelmakes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmBarrelMakeDTO) => {
    try {
      await createFirearmBarrelMake.mutateAsync(data);
      navigate('/admin/firearmbarrelmakes');
    } catch (error) {
      console.error('Error creating FirearmBarrelMake:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmbarrelmakes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmBarrelMake.Edit'
    >
        <FirearmBarrelMakeForm
          initialValues={{} as FirearmBarrelMakeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmbarrelmakes')}
        />
    </AdminLayout>
  );
};

export default FirearmBarrelMakeCreate;